import Axios from 'axios';
import { StandardError } from 'base/api/errors';
import { useBareListQuery } from 'base/api/hooks';
import { Puzzle } from 'base/api/types';
import apiUrls from 'base/api/urls';
import { CommonVars } from 'common/types';
import { composeUrl } from 'common/utils';
import { useMutation, useQueryClient } from 'react-query';

export const useMinisPuzzleUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, StandardError, CommonVars>(
    ({ pk, ...data }) =>
      Axios.patch(composeUrl(apiUrls.MINIS.PUZZLES, { params: { pk } }), data),
    {
      onSuccess: (data, vars) => {
        queryClient.refetchQueries([apiUrls.MINIS.DETAILS, { pk: vars.pk }]);
      },
    },
  );
};

export const usePuzzlesList = () => {
  return useBareListQuery<Puzzle>(apiUrls.PUZZLES.LIST);
};
